<template>
  <v-container>
    <h2>
      Les avantages d'HortusBox
    </h2>
    <br/>
    <v-row no-gutters>
      <v-col offset-md="2" md="8" align="center" justify="center">
        <table width="100%">
          <thead>
            <tr>
              <th>Avantages</th>
              <th>HortusBox</th>
              <th>Prestataire traditionnel</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Prix</td>
              <td>149 €</td>
              <td>> 1500 €</td>
            </tr>
            <tr v-for="(entry, i) in entries" :key="i">
              <td>{{entry.label}}</td>
              <td><MoreIcon :ok="entry.hb"/></td>
              <td><MoreIcon :ok="entry.other"/></td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MoreIcon from './MoreIcon'

export default {
  components: { MoreIcon },
  data: () => ({
    entries: [
      { label: 'Rendu réel en 3D', hb: true, other: true },
      { label: 'Budget maitrisé, pas de surprise', hb: true, other: false },
      { label: 'Service entièrement en ligne', hb: true, other: false },
      { label: 'Projet réalisable soi-même', hb: true, other: false },
    ]
  })
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}

h2 {
  text-align: center;
}
th {
  border-bottom: 1px solid black;
}
td {
  text-align: center;
}
tr {
  height: 4em;
}
</style>